import React from 'react';
import TextField from '@material-ui/core/TextField';

const inputComponent = ({ inputRef, ...otherProps }) => {
  return <div ref={inputRef} {...otherProps} />;
};

const JoinConversationInput = ({ children, selectProps, innerRef, innerProps }) => {
  return (
    <TextField
      fullWidth
      style={{
        height: '100%',
      }}
      InputProps={{
        inputComponent,
        inputProps: {
          className: selectProps.classes.input,
          inputRef: innerRef,
          children,
          ...innerProps,
        },
        disableUnderline: true,
      }}
      {...selectProps.textFieldProps}
      select={false}
      data-qa="searchAvaRoomInput"
    />
  );
};

export default JoinConversationInput;
